define(function (require) {
    var IpsModel = require('civicsBase/ipsModel');
    const ViewManager = require('civicsUtils/view_manager');
    //from http://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
    var toCamelCase = function (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
            return index == 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }
    return {
        parseToJSON: function (constraints, instrumentType) {
            var vals = {};
            var cons = {};
            var instrument = instrumentType.toUpperCase().replace(/ /g, "_");

            // Conversion of Instrument Type
            switch (instrumentType.toUpperCase()) {
              case 'BUSINESSLICENSE':
                instrument = 'BUSINESS_LICENSE';
                break;
              case 'TRADELICENSE':
                instrument = 'TRADE_LICENSE';
                break;
              default:
                break;
            }

            $.each(constraints, function (index, c) {
                var name;
                var msgName = c.name;
                var msg = null
                var allowRequire = true;
                switch(c.name.toLowerCase()) {
                  case 'associated sites':
                      name = 'additionalSites';
                      msg = i18n.t('CIVICS.COMMON.PLURAL_FIELDS_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.ASSOCIATED_SITES')});
                      break;
                  case 'primary site':
                      name = 'primarySite';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.PRIMARY_SITE');
                      break;
                  case 'applicants':
                      name = 'additionalApplicants';
                      msg = i18n.t('CIVICS.COMMON.PLURAL_FIELDS_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.ADDITIONAL_APPLICANTS')});
                      allowRequire = false;       //Primary Applicant is always set
                      break;
                  case 'additional applicants':
                      name = 'additionalApplicants';
                      msg = i18n.t('CIVICS.COMMON.PLURAL_FIELDS_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.ADDITIONAL_APPLICANTS')});
                      break;
                  case 'additional contacts':
                      name = 'additionalApplicants';
                      msg = i18n.t('CIVICS.COMMON.PLURAL_FIELDS_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.ADDITIONAL_APPLICANTS')});
                      break;
                  case 'contacts':
                      name = 'additionalApplicants';
                      msg = i18n.t('CIVICS.COMMON.PLURAL_FIELDS_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.ADDITIONAL_APPLICANTS')});
                      allowRequire = false;       //Primary Applicant is always set
                      break;
                  case 'description of project':
                      name = 'comments';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.DESCRIPTION');
                      break;
                  case 'dba name':
                      name = 'DBAName';
                      break;
                  case 'license category':
                      name = 'LicenseCategory';
                      break;
                  case 'type of business':
                      name = 'TypeOfBusiness';
                      break;
                  case 'business name':
                      name = 'BusinessName';
                      break;
                  case 'a/p name':
                      name = 'applicationName';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.TITLE');
                      break;
                  case 'project/phase name':
                      name = 'projectPhaseName';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.TITLE');
                      break;
                  case 'phase #':
                      name = 'PhaseNumber';
                      break;
                  case '# plans':
                      name = 'numberOfPlans';
                      msg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.NUMBER_OF_PLANS')});
                      break;
                  case '# pages':
                      name = 'numberOfPages';
                      msg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED', {field: i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.NUMBER_OF_PAGES')});
                      break;
                  case 'size/area':
                      // name = 'sizeArea';
                      name = 'squareFootage';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.SQUARE_FOOTAGE');
                      break;
                  case 'size description':
                      name = 'ProjectSizeDescription';
                      break;
                  case 'description of case':
                      name = 'comments';
                      break;
                  case 'case name':
                      name = 'apName';
                      break;
                  case 'subdivision':
                      name = 'subDivision';
                      break;
                  case 'declared valuation':
                      name = toCamelCase(c.name);
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.DECLARATION_VALUE');
                      break;
                  case 'description of work':
                      name = 'comments';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.DESCRIPTION');
                      break;
                  case 'square footage':
                      name = 'squareFootage';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.SQUARE_FOOTAGE');
                      break;
                  case 'comments':
                      name = 'comments';
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.DESCRIPTION');
                      break;
                  case 'start date':
                      name = toCamelCase(c.name);
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.START_DATE');
                      break;
                  case 'end date':
                      name = toCamelCase(c.name);
                      msgName = i18n.t('CIVICS.ADD_INSTRUMENT.' + instrument + '.END_DATE');
                      break;
                  case 'primary applicant':
                        name = toCamelCase(c.name);
                        allowRequire = false;       //Primary Applicant is always set, Primary applicant is now Required instead of default required.
                        break;
                    default:
                      name = toCamelCase(c.name);
                      break;
                }

                var val = {
                    required: false,
                };
                var con = {
                    readOnly:false,
                    editable:true,
                    hidden:false,
                    shown:true
                };
                if( allowRequire && c.setting.toLowerCase() == 'required') {
                    val.required = true;
                    if(msg!=null){
                        val.msg = msg
                    } else {
                        val.msg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED',{field:msgName});
                    }
                } else if(c.setting.toLowerCase() == 'notpresent'){
                    con.hidden = true;
                    con.shown = false;
                    con.editable = false;
                } else if(c.setting.toLowerCase() == 'displayonly'){
                    con.readOnly = true;
                    con.editable = false;
                }

                // Adding checks for the time values of the start and end date
                if(name == "startDate") {
                  let timeVal = JSON.parse(JSON.stringify(val));
                  timeVal.msg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED',{field: i18n.t('CIVICS.ADD_INSTRUMENT.USE.START_TIME')});
                  vals["startTime"] = timeVal;
                } else if (name == "endDate") {
                  let timeVal = JSON.parse(JSON.stringify(val));
                  timeVal.msg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED',{field: i18n.t('CIVICS.ADD_INSTRUMENT.USE.END_TIME')});
                  vals["endTime"] = timeVal;
                }

                vals[name] = val;
                cons[name] = con;
                // if(name!='calculatedValuation'
                // 	&& name != 'jobEstimation'
                // 	&& name != 'priority'
                // 	&& name.indexOf('#')<0
                // 	&& name != 'descriptionOfWork'){
                // 	val[name] = {
                // 		required:true
                // 	}
            });
            var useNewFields = ViewManager.versionRange('8.6.0.1909', '8.7') || ViewManager.versionRange('8.7.0.1912', '8.8') || ViewManager.versionRange('8.8.0.1911');
            if(useNewFields){
                //if we're using the new fields, set unit of measure's constraints to follow square footage's constraints.
                if(cons.squareFootage && instrument == "PROJECT"){
                    cons.unitOfMeasure = cons.squareFootage;
                    vals.unitOfMeasure = vals.squareFootage;
                }
                var defaults = {
                    editable:true,
                    shown:true,
                    hidden:false,
                    readonly:false
                };
                //if we're using the new fields, set these to always show/edit.
                cons.proposedStartDate = defaults;
                cons.proposedStopDate = defaults;
            } else {
                var dontShow = [
                'proposedStartDate',
                'proposedStopDate',
                'numberOfPlans',
                'numberOfPages',
                'calculatedValuation',
                'unitOfMeasure',
                'unitOfMeasureDescription',//does this even exist? -> looks like a calculated display only thing.
                'subdivision',
                'subdivisionDescription'//does this even exist? -> looks like a calculated display only thing
                ];
                $.each(dontShow, function(index, field){
                    //remove any associated validation, though there really shouldn't be any
                    $.each(vals,function(key,value){
                        if(key == field){
                            delete vals[key];
                        }
                    });
                    //overwrite any existing constraint, or add a new one with a hide always.
                    cons[field] = {
                        hidden:true,
                        shown:false,
                        editable:false
                    };

                });
            }

            return {
                validation:vals,
                constraints:cons
            };
        },
        parseToModel: function (constraints) {
            var model = new IpsModel();
            model.validation = this.parseToJSON(constraints);
            return model;
        }
    }
})
;
